/**
 * Predicate for zod `.refine()` that rejects empty objects. Use on schemas
 * where every field is optional but at least one must be supplied (e.g. PATCH
 * request bodies).
 */
export const hasAtLeastOneField = (value: Record<string, unknown>): boolean =>
  Object.keys(value).length > 0;
